import React from 'react';
import ResponsiveECharts from './ResponsiveECharts';
import { baseOption, axeCategorie, axeValeur } from './echartsTheme';
import { libelleHorizon, moyennePourHorizon } from '../utils/normaliserImpacts';
import { cleCouleurHorizon } from '../utils/horizon';
import { YEAR_COLORS } from '../constants';

/**
 * Évolution du risque moyen sur trois horizons.
 *
 * Remplace l'ancien GraphRiskMoy, qui affichait en dur deux courbes (+2 °C et
 * +4 °C) sur sept années. Ici une seule série, celle du scénario sélectionné,
 * chaque barre prenant la couleur de son horizon (YEAR_COLORS) ; les horizons
 * suivent le scénario : 2020 / 2035 / 2050
 * pour les scénarios en années, Référence / +2 / +2.7 en TRACC.
 *
 * @param scenario  clé de scénario ('2degre', '4degre', 'hybride', 'tracc')
 * @param moyennes  moyennes normalisées, indexées par scénario
 * @param horizons  les trois horizons à tracer, référence incluse
 */
export default function RisqueMoyenChart({ scenario, moyennes, horizons }) {
  const points = horizons.map((horizon) => ({
    horizon,
    valeur: moyennePourHorizon(moyennes, scenario, horizon),
  }));

  const disponibles = points.filter((p) => p.valeur !== undefined);
  if (disponibles.length === 0) {
    return <p className="tdb-chargement">Risque moyen indisponible pour ce scénario.</p>;
  }

  const option = {
    ...baseOption(),
    legend: { show: false },
    grid: { left: 12, right: 24, bottom: 40, top: 56, containLabel: true },
    tooltip: {
      trigger: 'axis',
      textStyle: { fontSize: 14, color: '#000000' },
      valueFormatter: (valeur) => `${Number(valeur).toFixed(1)} %`,
    },
    xAxis: axeCategorie({
      data: disponibles.map((p) => libelleHorizon(scenario, p.horizon)),
    }),
    yAxis: axeValeur({ nom: 'Pertes (%)', formatteur: (v) => `${v} %` }),
    series: [
      {
        type: 'bar',
        barMaxWidth: 72,
        label: {
          show: true,
          position: 'top',
          fontSize: 14,
          color: '#000000',
          formatter: ({ value }) => `${Number(value).toFixed(1)} %`,
        },
        data: disponibles.map((p) => ({
          value: p.valeur,
          itemStyle: {
            color: YEAR_COLORS[cleCouleurHorizon(scenario, p.horizon)] ?? '#7B1F2B',
          },
        })),
      },
    ],
  };

  return <ResponsiveECharts option={option} style={{ height: 320 }} />;
}
